import { render } from "./InstructorStats.vue?vue&type=template&id=68cc6321&scoped=true"
import script from "./InstructorStats.vue?vue&type=script&lang=js"
export * from "./InstructorStats.vue?vue&type=script&lang=js"

import "./InstructorStats.vue?vue&type=style&index=0&id=68cc6321&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68cc6321"]])

export default __exports__